import { PlainDatePeriodBox } from 'app/common/ui-next/_filter-compilations/plain-date-period'
import { defaultPeriod, periodFilter } from 'app/dataProviders/filter-items'

export const dateFormat = 'DD.MM.YYYY'

type Props = {
  id: string
  pending: boolean
  resetStatus: boolean
}

export const PeriodFilter = ({ id, pending, resetStatus }: Props) => {
  return (
    <PlainDatePeriodBox
      key={String(resetStatus)}
      id={id}
      label="Дата операции"
      fromLabel="с"
      toLabel="по"
      dateFormat={dateFormat}
      buttonResetLabel={null}
      calendarCloseOnClick
      skipUpperSpace
      loading={pending}
      dataBoxData={periodFilter}
      getDefaultState={() => defaultPeriod}
    />
  )
}
